import React from 'react';

import { Place } from '@mui/icons-material';
import {
  AppBar,
  Box,
  Button,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

import ConfigContext from '../../../context/config';
import useNonNullContext from '../../../hooks/useNonNullContext';
import { ZipCode } from '../FunnelNavBarHeader';
import NavBarLogo from '../NavBarLogo';

type Props = {
  leftComponent?: React.ReactNode;
  rightComponent?: React.ReactNode;
  position?: 'fixed' | 'absolute' | 'sticky' | 'static' | 'relative';
  zipCode?: ZipCode;
};

const NavBarLayout: React.FC<Props> = ({
  leftComponent,
  rightComponent,
  position,
  zipCode,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md'),
  );
  const configContext = useNonNullContext(ConfigContext);
  const { logoImgUrl, logoLinkUrl } = configContext.navBar;
  return (
    <AppBar
      position={position || 'static'}
      sx={{
        paddingLeft: 0,
        boxShadow: 'inset 0px -1px 0px ' + theme.palette.grey[300],
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Toolbar>
        <Box sx={{ flex: '1 1 0', minWidth: 0 }}>{leftComponent}</Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: '1 1 0',
            minWidth: 0,
            justifyContent: 'center',
          }}
        >
          <NavBarLogo logoImgUrl={logoImgUrl} logoLinkUrl={logoLinkUrl} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: '1 1 0',
            minWidth: 0,
            justifyContent: 'right',
          }}
        >
          {zipCode?.cartZipCode ? (
            <Button
              css={{
                textTransform: 'none',
                marginRight: !isSmallScreen ? '2rem' : undefined,
                whiteSpace: 'nowrap',
              }}
              onClick={() =>
                zipCode?.setZipCodeModalOpen &&
                zipCode.setZipCodeModalOpen(true)
              }
            >
              {isSmallScreen ? null : (
                <Typography variant="body2">Delivering to</Typography>
              )}
              <Typography
                variant="body2"
                css={{
                  textDecoration: 'underline',
                  marginLeft: '0.25rem',
                  fontWeight: 700,
                }}
              >
                {zipCode?.cartZipCode && zipCode.cartZipCode}
              </Typography>
              <Place color="primary" />
            </Button>
          ) : null}
          {rightComponent}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBarLayout;
